import { Injectable } from '@angular/core';
import { AuthentificationService } from '@app/authentification/authentification.service';

import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { Observable } from 'rxjs';
import { Dao } from '../dao';

@Injectable({
  providedIn: 'root',
})
export class IbanValidatorDao extends Dao {
  constructor(
    httpApi: HttpApiService,
    authentificationService: AuthentificationService,
  ) {
    super(httpApi, authentificationService);
  }

  validate({ iban, bic }: { iban: string; bic: string }): Observable<any> {
    return this.httpApi.post(`/iban/validator`, { iban, bic });
  }

  /* state */
  reset() {}

  onUserChange(event: any) {
    this?.reset();
  }
}
